// Mirrors PROMPT_TOKEN_RE in app/services/macros/execution_service.rb.
// Captures the prompt name, label (after |label=), and type (after |type=).
const PROMPT_TOKEN_RE =
  /\{\{\s*prompt:([a-zA-Z0-9_-]+)(?:\s*\|\s*label\s*=\s*([^|}]+))?(?:\s*\|\s*type\s*=\s*([a-zA-Z]+))?\s*\}\}/g;

const collectStrings = (value, acc) => {
  if (typeof value === 'string') {
    acc.push(value);
  } else if (Array.isArray(value)) {
    value.forEach(v => collectStrings(v, acc));
  } else if (value && typeof value === 'object') {
    Object.values(value).forEach(v => collectStrings(v, acc));
  }
};

// Extracts the unique list of {{prompt:NAME|label=...|type=...}} tokens
// declared anywhere inside a macro's action_params. Returns an ordered array
// of { name, label, type } descriptors so the UI can render an input per
// distinct prompt name (a name may appear multiple times across actions).
export const extractMacroPrompts = macro => {
  if (!macro || !Array.isArray(macro.actions)) return [];

  const strings = [];
  macro.actions.forEach(a => collectStrings(a?.action_params, strings));

  const byName = new Map();
  strings.forEach(s => {
    PROMPT_TOKEN_RE.lastIndex = 0;
    let match = PROMPT_TOKEN_RE.exec(s);
    while (match !== null) {
      const name = match[1];
      if (!byName.has(name)) {
        byName.set(name, {
          name,
          label: (match[2] || name).trim(),
          type: (match[3] || 'text').trim().toLowerCase(),
        });
      }
      match = PROMPT_TOKEN_RE.exec(s);
    }
  });

  return Array.from(byName.values());
};
